const DATA_FETCHING = "DATA_FETCHING";
const DATA_FETCHED = "DATA_FETCHED";

const COUNTRY_CHANGE = "COUNTRY_CHANGE";
const GET_COUNTRIES = "GET_COUNTRIES";
const GET_DAILY_DATA = "GET_DAILY_DATA";

export {
  DATA_FETCHING,
  DATA_FETCHED,
  COUNTRY_CHANGE,
  GET_COUNTRIES,
  GET_DAILY_DATA,
};
